import { Container, Stack, Typography } from "@mui/material";
import React from "react";
import LoginForm from "../forms/Login";
import UserCompteForm from "../forms/UserCompteForm";
import theme from "../../theme";

export default function LoginSection({onLogin}) {
    const [haveAccount, setHaveAccount] = React.useState(true);

    return haveAccount ? (
    <Container maxWidth="sm" sx={{ display: 'flex', flexDirection: 'column', minWidth: { xs: 280, sm: 300 }, backgroundColor: 'rgba(255, 255, 255, 0.8)', p: 3, borderRadius: 2 }}>
        <LoginForm {...{ onLogin }} />
        <Typography variant="body1" sx={{ mb: 2, alignSelf: 'end' }}>
        Pas encore de compte ?
        <span style={{ cursor: 'pointer', color: theme.palette.focus.main, marginLeft: 5 }} onClick={() => setHaveAccount(false)}>Je m'inscris</span>
        </Typography>
    </Container>
    ) : (
    <Container maxWidth="sm" sx={{ display: 'flex', flexDirection: 'column', minWidth: { xs: 320, sm: 400 }, height: '60vh', overflowY: 'auto', backgroundColor: 'rgba(255, 255, 255, 0.8)', p: 3, borderRadius: 2 }}>
        <UserCompteForm {...{ onLogin }} />
        <Typography variant="body1" sx={{ mb: 4, alignSelf: 'end' }}>
        Déjà inscrit ?
        <span style={{ cursor: 'pointer', color: theme.palette.focus.main, marginLeft: 5 }} onClick={() => setHaveAccount(true)}>Je me connecte</span>
        </Typography>
    </Container>
    )

    // <Container maxWidth='sm' sx={{ display:'flex', flexDirection:'column', minWidth: '300px', backgroundColor: 'rgba(255, 255, 255, 0.8)', padding: 3, borderRadius: 2 }}>
    //     <LoginForm {...{onLogin}} />
    //     <Typography variant="body1" sx={{ mb: 2, alignSelf: 'end' }}>
    //         Pas encore de compte ?
    //         <span style={{ cursor: 'pointer', color: theme.palette.focus.main, marginLeft: '5px' }}
    //                 onClick={() => setHaveAccount(false)}>Je m'inscris</span>
    //     </Typography>
    // </Container> 
    // : 
    // <Container maxWidth='sm' sx={{ display:'flex', flexDirection:'column', minWidth: '400px', height:'60vh', overflowY:'auto', backgroundColor: 'rgba(255, 255, 255, 0.8)', padding: 3, borderRadius: 2 }}>
    //     <UserCompteForm {...{onLogin}} />
    //     <Typography variant="body1" sx={{ mb: 4, alignSelf: 'end' }}>
    //         Déjà inscrit ?
    //         <span style={{ cursor: 'pointer', color: theme.palette.focus.main, marginLeft: '5px' }}
    //                 onClick={() => setHaveAccount(true)}>Je me connecte</span>
    //     </Typography>
    // </Container>
}